// /stories/: published stories (public Firestore read).
// Firebase loads lazily inside the page module (dynamic import), so the page paints and works
// without the SDK until it is needed.
import { init } from '../pages/stories.js';
import { logger } from '../lib/log.js';

Promise.resolve().then(init).catch((e) => {
  logger('stories').error('init_failed', { message: e && e.message, stack: e && e.stack });
});
